import React, { useEffect, useState } from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import { generateAxiosInstance } from '../hooks/useAuthorizedRequest';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../components/ModalsCommonFunctions';
import { findIndexById, findPageNumber, deleteItem, SortIcon, searchArray } from '../components/Navigation';
import Pagination from '../components/Pagination';

const InstituteSubjectForApproval = () => {
    const authorizedAxios = generateAxiosInstance()
    const [instituteSubjectList, setInstituteSubjectList] = useState([])

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);
    const [addNew, setAddNew] = useState(false);

    const [subjectSort, setSubjectSort] = useState(null);
    const [instituteSort, setInstituteSort] = useState(null);
    const [emailSort, setEmailSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["subjectName", "instituteSubjectMasterDetails.instituteMasterDetails.instituteName", "instituteSubjectMasterDetails.instituteMasterDetails.email"];

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getUnapprovedSubject();
    }, []);

    const getUnapprovedSubject = async () => {
        try {
            setLoading(true);
            let apiUrl = "/get-un-approved-subject";
            const response = await authorizedAxios.get(apiUrl);
            setInstituteSubjectList(response.data.result);
        } catch (error) {
            setInstituteSubjectList([]);
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            console.log(errorMsg);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            getUnapprovedSubject();
        }
    }, [searchValue]);

    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            setCurrPage(1);
            setInstituteSubjectList(await searchArray("A", "/get-un-approved-subject", searchKeys, searchValue.trim()));
        }
    }

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(instituteSubjectList, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId, addNew])

    useEffect(() => {
        setTotalPages(Math.ceil(instituteSubjectList.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > instituteSubjectList.length) {
            endIndex = instituteSubjectList.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(instituteSubjectList.slice(startIndex, endIndex));
    }, [instituteSubjectList, currPage, itemsPerPage]);

    const changeActive = async (id) => {
        try {
            setLoading(true);
            const apiUrl = `/approve-institute-subject?id=${id}`;
            const response = await authorizedAxios.patch(apiUrl);
            Swal.fire({ text: response.data.message });
        } catch (error) {
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            Swal.fire(
                { text: errorMsg }
            );
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (subjectSort == true || subjectSort == false) {
            setInstituteSort(null);
            setEmailSort(null);
        }
    }, [subjectSort])

    useEffect(() => {
        if (instituteSort == true || instituteSort == false) {
            setSubjectSort(null);
            setEmailSort(null);
        }
    }, [instituteSort])

    useEffect(() => {
        if (emailSort == true || emailSort == false) {
            setSubjectSort(null);
            setInstituteSort(null);
        }
    }, [emailSort])

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>Institute Subject Approve</span></li>
                        </ol>
                    </nav>
                </div>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-file-lines"></i> Institute Subject Approve</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table">
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>
                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col" className='sl_no'>Sr. No.</th>
                                                                        <th scope="col">
                                                                            Subject Name
                                                                            <SortIcon sortState={subjectSort} setSortState={setSubjectSort} setData={setInstituteSubjectList} setCurrPage={setCurrPage} sortingPath={"subjectName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Institude Name
                                                                            <SortIcon sortState={instituteSort} setSortState={setInstituteSort} setData={setInstituteSubjectList} setCurrPage={setCurrPage} sortingPath={"instituteSubjectMasterDetails.instituteMasterDetails.instituteName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Institute Email
                                                                            <SortIcon sortState={emailSort} setSortState={setEmailSort} setData={setInstituteSubjectList} setCurrPage={setCurrPage} sortingPath={"instituteSubjectMasterDetails.instituteMasterDetails.email"} />
                                                                        </th>
                                                                        <th scope='col'>Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        displayedData?.length > 0 ?
                                                                            displayedData?.map((subject, index) => {
                                                                                return (
                                                                                    <tr>
                                                                                        <th scope="row" className='sl_no'>{index + 1}</th>
                                                                                        <td>{subject?.subjectName}</td>
                                                                                        <td>{subject?.instituteSubjectMasterDetails?.instituteMasterDetails?.instituteName}</td>
                                                                                        <td>{subject?.instituteSubjectMasterDetails?.instituteMasterDetails?.email}</td>
                                                                                        <td>
                                                                                            <button className='btn btn-success approve_icon' onClick={() => changeActive(subject?.id)}>Approve</button>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No Institute Subject Available</th>
                                                                            </tr>)
                                                                    }
                                                                </tbody>
                                                            </table>
                                                            <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={instituteSubjectList.length} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default InstituteSubjectForApproval
